import React from 'react';
import { Grid, Skeleton, Box } from '@mui/material';
import { styled } from '@mui/system';

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  borderRadius: '12px',
  height: '224px',
  width: '360px',
  background: `${theme.palette.action.hover} !important`,
}));

const SkeletonContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'rowGap' && prop !== 'columnGap',
})(({ rowGap, columnGap }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))',
  rowGap: rowGap || '16px',
  columnGap: columnGap || '24px',
  width: '100%',
  padding: 0,
  margin: 0,
}));

const PageCardsSkeleton = ({
  count = 12,
  skeletonStyles = {},
  containerStyles = {},
  useGridContainer = true,
  gridProps = {},
  rowGap = '16px',
  columnGap = '24px',
}) => {
  const skeletonItems = Array.from({ length: count }, (_, index) => (
    <StyledSkeleton
      key={index}
      variant="rectangular"
      animation="wave"
      sx={skeletonStyles}
    />
  ));

  if (useGridContainer) {
    return (
      <SkeletonContainer rowGap={rowGap} columnGap={columnGap} sx={containerStyles}>
        {skeletonItems}
      </SkeletonContainer>
    );
  }

  // When useGridContainer is false, return Grid items directly (for use within an existing Grid container)
  return Array.from({ length: count }, (_, index) => (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={index}>
      <StyledSkeleton variant="rectangular" animation="wave" sx={skeletonStyles} />
    </Grid>
  ));
};

export default PageCardsSkeleton;
